import { watchover, installQueueDrain } from "./index.js";

/**
 * Browser entry (built to /watchover.js). Self-initializes from the loading
 * <script> tag's data-* attributes (or window.watchoverConfig), then drains any
 * commands the page queued via the `wo(...)` stub before the bundle loaded.
 *
 * Loading is fully async and nothing here touches layout, so the host page's
 * critical rendering path is never blocked.
 */
// Capture the loading <script> now — document.currentScript is only valid
// during synchronous module execution, not inside a deferred callback.
const scriptEl =
  document.currentScript instanceof HTMLScriptElement
    ? document.currentScript
    : null;

function boot() {
  // Expose the rich object API too: watchover.track(...), etc.
  (window as any).watchover = watchover;

  // Auto-init unless the page opted out with data-manual / watchoverConfig.manual.
  const manual =
    (window as any).watchoverConfig?.manual === true ||
    scriptEl?.getAttribute("data-manual") != null;
  if (!manual) watchover.init();

  // Wire up the short stub name `wo(...)` if the page used the queue pattern.
  installQueueDrain("wo");
}

if (document.readyState === "loading") {
  // DOM not ready: defer just past parsing so currentScript/data-* are stable,
  // but recording still starts well before load/onload.
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}

export { watchover };
